module.exports = __webpack_public_path__ + "static/media/ShopOnBudget3.7fecd4e3.png";